
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import xtend from "xtend";
import Breakpoints from "react-native-dimensions-breakpoints";

var colors = {
	primary: "#065B61",
	secondary: "#237480",
	tertiary: "#59a9b0",
	highlight: "#C55050",
	alert: "#B24242",
	alertLight: "#f3eeee",
	grey: "#787878",
	medium: "#394245",
	dark: "#202020",
	black: "#000000",
	white: "#FFFFFF",
	light: "#EDF2F3",
	tertlight: "#D2E3E6",
	darkBlue: "#013539",
	darkBlueGreen: "#2a2a2a",
	darkGreyBlack: "#131618",
	semiDarkGrey: "#393939",
	semiDarkBlue: "#005d63",
	semiLightGrey: "#797979",
	lightGrey: "#e8e8e8",
	lightBlue: "#7dd1f5",

	grayblack: "#394245",
	grayblue: "#055781",
	red: "#c55050",
	yellow: "#f0c600",
	orange: "#FFA726",
	gray: "#6e787c",
	green: "#01a276",
	lightOrange: "#ffd59d",

	semitransGreen: "rgba(1, 162, 118, 0.5)",
	semitransYellow: "rgba(240, 198, 0, 0.5)",
	semitransRed: "rgba(197, 80, 80, 0.5)",

	itemLight: "#EEF2F2",
	itemBlue: "#DEF2F2",
	itemLightGray: "#EDF2F3",
	itemGray: "#DCE3E5",
	overlay: "rgba(6, 91, 97, 0.95)",
	spinneroverlay: "rgba(255,255,255,.85)",

	shadow: "rgba(0,0,0,0.3)",
	clear: "rgba(0,0,0,0)",

	gradientStart: "#3c8a91",
	gradientEnd: "#58A8AE",

	toastBackground: "rgba(51, 51, 51, 0.9)",
};

var look = {
	blurRadius: 6,
	text: colors.primary,
	background: colors.white,
	sectionBackground: colors.light,
	sectionOutline: colors.secondary,
	outline: colors.white,
	disabled: 0.4,
	alert: colors.alert,
	alertBackground: colors.alertLight,
	chatBackground: colors.light,
	chatBackgroundAlternate: colors.tertlight,
	disconnected: colors.orange,

	secondaryBackground: colors.tertiary,
	highlight: colors.highlight,
	shadow: colors.shadow,
	detailsWhiteBackground: colors.careplanDetailBackground,
};

look.contrast = xtend(look, {
	text: colors.white,
	background: colors.primary,
	sectionBackground: colors.secondary,
});

var layout = {
	badge: 3,
	squareButton: 104,
	squareButtonStretch: 126,
	maxContent: 600,
	smallContent: 432,

	paddingContent: 60,
	paddingSlim: 4,
	paddingList: 6,
	paddingSmall: 8,
	paddingButton: 14,
	paddingMedium: 22,
	paddingLarge: 40,

	marginSlim: 4,
	marginSmall: 8,
	marginMedium: 18,
	marginBordered: 20,
	marginLarge: 22,
	marginHuge: 32,

	marginContentSmall: 12,
	marginContent: 60,
	marginContentVertical: 40,

	controlButtons: 80,
	border: 1,
	atouchaway: {
		border: 24,
		inputBorder: 12
	},
};

var text = {
	tiny: 10,
	verySmall: 12,
	small: 14,
	standard: 18,
	emphasized: 22,
	smallHeading: 28,
	large: 32,
	largeHeading: 38,
	hugeHeading: 48,
	hugeIcon: 100,
};

var imageSize = {
	icon: 26,
	tiny: 36,
	mini: 52,
	extrasmall: 80,
	verysmall: 142,
	quitesmall: 204,
	small: 194,
	medium: 230,
	minilarge: 260,
	large: 392,
	verylarge: 398
};

var breakpoints = {
	smallTablet: 601,
	mobile: 512,
	mobileSmall: 376,
	small: 321,
};

Breakpoints.configure(breakpoints);

var steps = [
	4,
	8,
	16,
	24,
	32,
	40,
	48,
	56,
	64,
	72,
	80,
	88,
	96,
	104,
	112,
	128
];

export default {
	colors: colors,
	text: text,

	look: look,
	layout: layout,
	imageSize: imageSize,
	steps: steps,
	breakpoints: breakpoints,
};
